import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=4e6dd4b0&scoped=true&"
import script from "./orderDetail.vue?vue&type=script&lang=js&"
export * from "./orderDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=4e6dd4b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6dd4b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e6dd4b0')) {
      api.createRecord('4e6dd4b0', component.options)
    } else {
      api.reload('4e6dd4b0', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=4e6dd4b0&scoped=true&", function () {
      api.rerender('4e6dd4b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/order/orderDetail.vue"
export default component.exports